import { Typography } from "antd";
import { Reducer } from "react";

export enum QueryStateCustomAttributeNameMap {
  location = "office_names",
  employmentType = "employment_type",
  department = "department_names",
  marketIds = "market_ids",
  jobTpe = "work_environment",
}

export enum JobKind {
  prospect = "prospect",
  regular = "regular",
}

export type QueryState = {
  q: string;
  location: string;
  department: string;

  employmentType: string;
  locationSlug: string;
  marketIds: string;
  commuteFilter: boolean;
  commuteLat: string;
  commuteLon: string;
  commuteLabel: string;
  commutePlaceId: string;
  jobType: string;
  jobLocationLat: string;
  jobLocationLon: string;
  jobLocationAddress: string;
};

export type QueryAction =
  | {
      type: "reset";
    }
  | {
      type: "update_q";
      value: QueryState["q"];
    }
  | {
      type: "update_custom_department";
      value: QueryState["department"];
    }
  | {
      type: "update_custom_location";
      value: QueryState["location"];
    }
  | {
      type: "update_custom_employmentType";
      value: QueryState["employmentType"];
    }
  | {
      type: "update_commute_filter";
      value: QueryState["commuteFilter"];
    }
  | {
      type: "update_commute_filter_params";
      value: {
        commuteLat: QueryState["commuteLat"];
        commuteLon: QueryState["commuteLon"];
        commuteLabel: QueryState["commuteLabel"];
        commutePlaceId: QueryState["commutePlaceId"];
      };
    }
  | {
      type: "update_job_type";
      value: QueryState["jobType"];
    }
  | {
      type: "update_job_location";
      value: {
        jobLocationLat: QueryState["jobLocationLat"];
        jobLocationLon: QueryState["jobLocationLon"];
        jobLocationAddress: QueryState["jobLocationAddress"];
      };
    };

export type QueryReducer = Reducer<QueryState, QueryAction>;

export type AppletProps = {
  /**
   *  Optional: define starting search params for inline components, which will also update silently
   *  and not mutate the url search params
   *
   *  Example: ?employmentType=internship%2C+non-exempt
   */
  inlineSearchParams?: Record<string, unknown>;
  searchParams: Record<string, unknown>;
  header: boolean;
  headerText: string;
  headerLevel: Exclude<
    Parameters<typeof Typography.Title>[0]["level"],
    undefined
  >;
  /**
   * Indicates whether the search should be triggered immediately on each filter update
   * or only when the search button is clicked.
   * 
   * Default: true
   */
  instantSearch: boolean;
  /**
   * Primary Controls for the job board which inlcuded location search, keyword search, and job type
   *
   * Default: true
   */
  primaryControls: boolean;
  facets: boolean;
  /**
   * Indicates if the job board should show search results
   *
   * Default: true
   */ 
  searchResults: boolean;
  /**
   * Indicates if the job board should show the "Clear All" button
   * Clear all button is applicable only when the mode is instant search
   * Default: true
   */ 
  clearAllOption?: boolean;
  locationSlug?: string;
};

export type JobTypeFilterMap = { frontend: string; backend: string }[]
